import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Reaction } from 'src/app/models/Reaction';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';

@Injectable({
  providedIn: 'root',
})
export class ReactionService {
  emojiList: string[] = ["❤️", "👍", "🙏", "😀", "🤣", "😂", "😇", "😄", "😆", "😅", "🙃", "😉", "😊", "😍", "🤩", "😘", "😗", "😋", "😛", "😜", "🤪", "🤑", "🤗", "🤭", "🤫", "🤔", "🤐", "🤨", "😐", "😏", "😒", "🙄", "😬", "🤥", "😌", "😔", "😪", "😴", "😷", "🤒", "🤕", "🤢", "🤮", "🤧", "🤯", "🤠", "😎", "😕", "😟", "☹️", "😮", "😯", "😳", "😨", "😥", "😢", "😭", "😱", "😖", "😣", "😫", "😤", "😡", "😠", "🤬", "😈", "👿", "💬"];
  reaction: Reaction = new Reaction;
  reactionList: Reaction[] = [];

  constructor(private backEnd: BackEndService, private auth: AuthService) {
  }
  getReaction(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.REACTION, [[variable, id]], 0, 100, 'created_at', false).then((reactionList: Reaction[]) => {
        this.reactionList = reactionList;
        for (let reaction of this.reactionList) {
          if (reaction.creator && ((typeof reaction.creator === 'string'))) {
            reaction.creator = JSON.parse(reaction.creator);
          }
        }
        console.log(this.reactionList);
        resolve(true);
      })
    })
  }
  getUserReaction(empId, feedId, type): Promise<Reaction[]> {
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.REACTION, [["emp_id", empId], ["feed_id", feedId], ["type", type]]).then((reactionList: Reaction[]) => {
        resolve(reactionList);
      })
    })
  }


  saveObject() {
    return new Promise((resolve) => {

      this.reaction.created_by = this.auth.loggedInEmployee.user.id;
      this.reaction.emp_id = this.auth.loggedInEmployee.id;
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.REACTION, this.reaction).then((response) => {
        if (response) {
          this.reactionList.push(this.reaction);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

}
